// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__342S1","header":"ReportDetails_header__1HZ3n","title":"ReportDetails_title__2pOt8","left":"ReportDetails_left__2WyyA"};